<template>
    <div style="font-size: 23.4375px;">
        <!--    导航栏-->
        <Anav pro="0"></Anav>
        <!--    标签栏-->
        <Atablebar></Atablebar>
        <div class="box">
            <!--            视频-->
            <div class="video-box" alt="视频">
                <video id="videosPlay"  muted controls="controls" style="object-fit:contain;width:100%;" class="mobiVideo" poster="https://h5.yibaojihua.com/shianbao.jpg">
                    <source src="https://h5.yibaojihua.com/shianbao.mp4" type="video/mp4">
                    抱歉，您的浏览器不能查看该视频。
                </video>
            </div>

            <!--            内容-->
            <div class="content">
                <div class="title-box">
                    <div class="title">
                        <div id="title" aria-label="保险产品">保险产品</div>
                        <div role="button" aria-label="查看全部" @click="lookall">查看全部</div>
                    </div>
                </div>

                <!--                list-->
                <div class="list-box">
                    <div class="list-item" v-for="(item,index) in asblist" @click="lookinfo(item)" :key="index" role="button" :aria-labelledby="['listItem' + index]" >
                        <div class="img-item"><img :src=item.image alt="产品图片"></div>
                        <div class="content-item">
                            <div class="title-item" :id="['listItem' + index]" aria-hidden="true">{{item.prodName}}</div>
                            <div class="text-item">{{item.prodDescribe}}</div>
                            <div class="money-item">￥{{item.price}}</div>
                        </div>
                    </div>
                </div>
            </div>


            <!--            一对一顾问服务-->
            <div class="consultant-title" role="button" aria-labelledby="yiduiyi">
                <div class="consultant-title-center">
                    <div id="yiduiyi" aria-hidden="true">一对一的顾问服务</div>
                    <div>SERVICE</div>
                </div>
            </div>

            <!--            顾问内容-->
            <div class="consultant-list">
                <a v-for="(item,index) in consultantList" :key="index" @click="jump(item.id)" role="button" :aria-labelledby="['xuanxiang' + index]" >
                    <div class="item_center" @click="openwindows(item)">
                        <img :src="item.icon" alt="">
                        <span :id="['xuanxiang' + index]" aria-hidden="true">{{item.name}}</span>
                    </div>
                </a>
            </div>

            <!--            关于我们-->
            <div class="about-us">
                <div class="about-us-center" aria-labelledby="guanyutit guanyu">
                    <div id="guanyutit" aria-hidden="true">关于我们</div>
                    <div id="guanyu" aria-hidden="true">
                        <p>为让全国千万视力障碍者同样获得保险保障，益宝牵头与信息无障碍研究会联合设计和倡导、平安承保的“视安保：视力障碍者保险”。</p>
                        <p>视安保一共三款产品，意外险、重疾意外险、意外责任险，服务于视力障碍者自身和工作单位根据需求选择合适的产品参保，服务视力障碍者的公益组织也可以筹资进行保险捐赠。</p>
                    </div>
                </div>

            </div>
        </div>
        <div v-if="hidden" class="wechat" @click="hiddenWechat()" aria-labelledby="erweima" role="dialog" tabindex="0">
            <div><img id="erweima" :src="wechat" aria-hidden="true" alt="二维码，长按添加"></div>
        </div>
    </div>

</template>

<script src="https://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
<script>

    import Vue from 'vue';
    import {Field, Button, Notify, Icon} from 'vant';
    //引入导航组件
    import Anav from './Acomponent/Anav';
    import Atablebar from './Acomponent/Atablebar';
    // 引入icon
    import icon_list_1 from '@/views/anshibao/icon/AhomeIcon/icon_list_1.png';
    import icon_list_2 from '@/views/anshibao/icon/AhomeIcon/icon_list_2.png';
    import icon_list_3 from '@/views/anshibao/icon/AhomeIcon/icon_list_3.png';
    import icon_list_4 from '@/views/anshibao/icon/AhomeIcon/icon_list_4.png';
    import icon_list_5 from '@/views/anshibao/icon/AhomeIcon/icon_list_5.png';
    import icon_list_6 from '@/views/anshibao/icon/AhomeIcon/icon_list_6.png';
    import weixin from '@/views/anshibao/icon/AhomeIcon/weixin.jpg';
    import Cookies from "js-cookie";

    // import "http://res.wx.qq.com/open/js/jweixin-1.0.0.js"
    Vue.use(Field).use(Button).use(Notify);
    Vue.use(Icon);

    export default {
        components:{
            Anav,
            Atablebar,
        },

        name: "Login",
        data() {
            return {
                hidden:0,
                // images:'',
                tel : "010-86464262",
                wechat : weixin,
                QQ : "http://wpa.qq.com/msgrd?v=3&uin=3066619203&site=qq&menu=yes",
                consultantList:[
                    {
                        id : 1,
                        name : "保单查询",
                        icon : icon_list_1
                    },
                    {
                        id : 2,
                        name : "常见问题",
                        icon : icon_list_2
                    },
                    {
                        id : 3,
                        name : "理赔流程",
                        icon : icon_list_3
                    },
                    {
                        id : 4,
                        name : "客服电话",
                        icon : icon_list_4,

                    },
                    {
                        id : 5,
                        name : "客服微信",
                        icon : icon_list_5,

                    },
                    {
                        id : 6,
                        name : "客服QQ",
                        icon : icon_list_6,

                    },
                ],
                asblist:[]
            }
        },
        props: {
            name: {}
        },
        created() {
            this.getAsbList("")
            // this.bofang()
        },
        watch: {
            $route: {
                handler: function(val, oldVal){
                    this.getAsbList(val.query.proname)
                },
            }
        },
        methods: {
            // bofang(){
            //     wx.ready(function () {
            //         wx.getNetworkType({
            //             success:function (res) {
            //                 document.getElementById('videosPlay').play()
            //             }
            //         })
            //     })
            // },

            getAsbList(proname){
                if(proname!=""){
                    this.$axios.get("/product/listAnShiBao?type=0&prodTag=1&prodName="+proname+"&sort=desc").then(res=>{
                        if(res.data.rows==0){
                            Notify({ type: 'danger', message: '没有匹配内容！'})
                        }
                        this.asblist=res.data.rows
                    })
                }else{
                    this.$axios.get("/product/listAnShiBao?type=0&prodTag=1&prodTag=1&prodName=&pageSize=4&sort=desc&page=1").then(res=>{
                        this.asblist=res.data.rows
                    })
                }

            },
            jump(id){
                switch (id) {
                    case 1:
                        window.location.href = "./AInsurancePolicy?type=0"
                        break;
                    case 2:
                        window.location.href = "./Aproblem?type=0&product=0"
                        break;
                    case 3:
                        window.location.href = "./AclaimsProcess?type=0"
                        break;
                    case 4:
                        window.location.href = 'tel://' + this.tel
                        break;
                    case 5:
                        this.hidden = 1
                        break;
                    case 6:
                        Notify({ type: 'primary', message: '正在打开qq'})
                        location.href = "http://wpa.qq.com/msgrd?v=3&uin=1843363584&site=qq&menu=yes"
                        break;
                }
            },
            openwindows(n){
                switch(n.id){
                    case 4:
                        location.href='tel://'+n.tel;
                        // eslint-disable-next-line no-fallthrough
                        break;
                    case 5:
                        this.images = n.wechat
                        this.hidden = 1
                        break;
                    // eslint-disable-next-line no-duplicate-case,no-fallthrough
                    case 6:
                        Notify({ type: 'primary', message: '正在打开qq'})
                        location.href = n.QQ
                        break;
                }
            },
            // 微信弹窗
            hiddenWechat(){
                this.hidden = 0
            },
            lookall(){
                this.$router.push("/Aproduce?type=0")
            },
            lookinfo(item){
                this.$axios.get("/jump/aprodUrl", {
                    params: {
                        productId: item.productId,
                        shareId: Cookies.get('shareId')
                    }
                }).then(res => {
                    window.location.href = res.data
                }).catch((e) => {});
            }
        }
    }
</script>

<style scoped>
    .box{
        margin-bottom: 3rem
    }
    .video-box{
        padding-top: 3rem;
        width: 100%;
    }
    .content{
        width: 100%;
        background-color: #fff;
        margin-top: 12px;
    }
    .content .title{
        width: 92vw;
        display: flex;
        justify-content: space-between;
        color: #aaa;
        margin: 0 auto;
        font-size: 1rem;
        line-height: 3rem;
    }
    .content .title-box{
        width: 100%;
        border-bottom: 1px solid #eee;

    }
    .content .title div:first-child{
        font-weight: bold;
        font-size: 1.2rem;
        color: #333!important;
    }
    /*列表*/
    .content .list-box{
        width: 92vw;
        margin: 0 auto;
    }
    .content .list-box .list-item{
        width: 100%;
        display: flex;
        border-bottom: 1px solid #eee;
        margin-top: 20px;
    }
    .content .list-box .list-item:last-child{
        border: none;
    }
    .content .list-box .list-item .img-item{
        width: 100px;
        height: 100px;
        border-radius: 4px;
        overflow: hidden;
        flex-shrink:0;
        margin-bottom:20px
    }
    .content .list-box .list-item .img-item img{
        width: 100%;
        height: 100%;
    }
    .content .list-box .list-item .content-item{
        font-size: 1rem;
        line-height: 1.5rem;
        margin-left: 4vw;
        width: 100%;
    }

    .content .list-box .list-item .content-item .title-item{
        color: #101010;
        font-style: normal;
        font-weight: bold;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .content .list-box .list-item .content-item .text-item{
        color: #999;
    }
    .content .list-box .list-item .content-item .money-item{
        color: rgba(2, 150, 136, 1);
        font-size: 1.2rem;
        font-weight: bold;
        line-height: 1.4rem;
        margin-top: 8px;
    }

    /*一对一顾问*/
    .consultant-title{
        width: 100%;
        background-color: #fff;
    }
    .consultant-title .consultant-title-center{
        color: rgb(73, 110, 232);
        text-align: center;
        font-size: 1rem;
        line-height: 32px;
        padding: 56px 0 8px;
    }
    .consultant-title .consultant-title-center div:first-child{
        font-size: 1.4rem;
        font-weight: bold;
    }
    /*顾问列表*/
    .consultant-list{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        background-color: #fff;
        padding-bottom: 20px;
    }
    .consultant-list a{
        display: block;
        width: 49.6%;
        height: 120px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }
    .consultant-list>a:nth-child(odd){
        border-right: 1px solid #eee;
    }
    .item_center{
        line-height: 120px;
        display: flex;
        color: #101010;
        font-size: 1.2rem;
        font-weight: bold;
        /*不允许选中文字*/
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
    }
    .item_center img{
        display: block;
        margin: 40px 16px 0 24px;
        width: 2.4rem;
        height: 2.4rem;
        -webkit-user-drag: none;
    }

    /*关于我们*/
    .about-us{
        width: 100%;
        background-color: #fff;
        margin: 20px auto 20px;
    }
    .about-us .about-us-center{
        width: 88%;
        margin: 0 auto;
        padding-bottom: .8rem;
        text-align: justify;
        font-size: 1.1rem;
        line-height: 30px;
    }
    .about-us .about-us-center div:first-child{
        color: rgb(38, 165, 154);
        font-size: 1.4rem;
        line-height: 64px;
        text-align: center;
        font-weight: bold;
    }
    /*微信弹窗*/
    .wechat{
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,.3);
        position:fixed;
        top: 0;
        left: 0;
    }
    .wechat div{
        width: 60vw;
        min-height: 60vw;
        background-color: #fff;
        margin: 30vh auto;
        border-radius: 16px;
    }
    .wechat div img{
        width:80%;
        margin-top: 10%;
        margin-left: 10%;
    }
</style>
